<template>
<div>
    <base-header v-once pageName="개인정보 수집 및 이용 동의" :popup="true"></base-header>
    
    <section id="wrap">
        <div class="agreement">
            <dl>
                <dt>개인정보 수집 및 이용</dt>
                <dd>
                    <strong>1. 수집 및 이용 목적</strong>
                    <div>상품안내, 이벤트안내 제공(상담, 접수, 방문전달, 문의응대)</div>
                </dd>
                <dd>
                    <strong>2. 수집 및 이용 항목</strong>
                    <div>
                        필수 : 고객 성명, 전화번호, 자녀 성명, 자녀 생년월일<br/>
                        선택 : 고객 생년월일
                    </div>
                </dd>
                <dd>
                    <strong>3. 보유 및 이용기간</strong>
                    <div>상품 및 이벤트 안내 제공 완료 후 파기</div>
                </dd>
                <dd>
                    <strong>4. 거부권 및 거부 시 불이익</strong>
                    <div>귀하는 이 동의를 거부할 권리가 있으나, 동의 거부 시 상품 및 이벤트 안내 제공이 불가합니다.</div>
                </dd>
            </dl>
            <dl>
                <dt>마케팅 목적 활용 동의</dt>
                <dd>
                    <strong>1. 수집 및 이용 목적</strong>
                    <div>전화, 문자 또는 카카오 알림톡을 통한 할인정보, 상품홍보 등 광고성 정보 발송</div>
                </dd>
                <dd>
                    <strong>2. 수집 및 이용 항목</strong>
                    <div>
                        고객 : 성명, 주소, 전화번호, 생년월일<br/>
                        자녀 : 성명, 생년월일                     
                    </div>
                </dd>
                <dd>
                    <strong>3. 보유 및 이용기간</strong>
                    <div>동의일로부터 12개월까지</div>
                </dd>
                <dd>
                    <strong>4. 거부권 및 거부 시 불이익</strong>
                    <div>
                        ㈜교원에듀와 계약된 위탁사업자가 광고성 정보 전송을 대행할 수 있습니다.<br/>
                        귀하는 이 동의를 거절할 수 있으며, 동의 거부 시에도 상품 및 이벤트 안내 제공이 가능합니다.
                    </div>
                </dd>
            </dl>
        </div>
    </section>  
</div>
</template>

<script>
export default {
  data() {
      return{
      };
  },
  methods: {
  },
  mounted: function() { //  인스턴스가 마운트 된 직후
  }
};
</script>
